module.exports = __webpack_public_path__ + "static/media/north-gate-logo.3b1e56ee.png";